// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"ffc1813b2604825a","803":"4d955d690a4c1207"}[chunkId] + ".js";
};